import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useEstimateStructure } from "@tools";
import { InfoLabel, TextField } from "@components";
import { Grid } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

export const BufferDisplaySelect = observer(() => {
  const { t } = useTranslation();
  const structure = useEstimateStructure();
  
  const handleVariantChange = (e, v) => {
    structure.settings.setMaxValuesAsBuffer(v === "2");
  }
  
  return <Grid
    item container
    // justifyContent="space-between"
    alignItems="flex-end"
    direction="column"
    className="mt-4"
  >
    <InfoLabel
      label={t("views.editor.dialogs.buffers.display_mode")}
      className="w-172"
    />
    <Autocomplete
      id="bufferModeSelect"
      value={structure.settings.maxValuesAsBuffer ? "2" : "1"}
      size="small"
      onChange={handleVariantChange}
      getOptionSelected={(o, v) => o === v}
      getOptionLabel={(o) => t("buffer_mode." + o)}
      disableClearable
      options={["1", "2"]}
      renderInput={(params) => (
        <TextField {...params} label="" className="mb-0 w-172" />
      )}
    />
  </Grid>
})